import React from 'react';
import InlineEditableElement from '../../Components/InlineEditableElement';
import {File} from 'FW/Models/File';
import CommentBox from './CommentBox';
import moment from 'moment';
import ShareButtons from 'Views/ShareButtons';
import SubscribeField from './SubscribeField';

class BlogPost extends React.Component {
  constructor(props) {
    super(...arguments);
    let featuredImage = props.post.get('featured_image')
      ? File.findOrCreate({
          id: props.post.get('featured_image')
        })
      : null;
    this.state = {
      featuredImage: featuredImage,
      inlineEditingEnabled: false
    };
    this.valueChanged = this.valueChanged.bind(this);
  }

  componentDidMount() {
    let props = this.props;
    this.props.post.on('edit:start', () => {
      this.setState({
        inlineEditingEnabled: true
      });
    });
    this.props.post.on('edit:stop', () => {
      this.setState({
        inlineEditingEnabled: false
      });
    });
    this.props.post.on(
      'change sync edit:start edit:stop',
      () => {
        let featuredImage = props.post.get('featured_image')
          ? File.findOrCreate({
              id: props.post.get('featured_image')
            })
          : null;
        this.setState({
          featuredImage: featuredImage
        });
      },
      this
    );
    if (typeof this.props.post.prop('fonts') !== 'undefined') {
      this.loadFonts(this.props.post.prop('fonts'));
    }
  }

  componentWillUnmount() {
    this.props.post.off(null, null, this);
  }

  valueChanged(value) {
    this.props.post.set('content', value);
  }

  loadFonts(fonts, callback) {
    this.loadedFonts = this.loadedFonts || [];
    fonts.forEach(fontName => {
      if (fontName) {
        if (!this.loadedFonts.includes(fontName)) {
          if (window.WebFont)
            window.WebFont.load({
              google: {
                families: [fontName]
              }
            });
        }
      }
    });
  }

  fontFamilyChanged = (fonts) => {
    this.props.post.prop('fonts', fonts);
  }

  render() {
    let shape = 'round';
    let post = this.props.post;

    if (post.get('blog') === null) {
      return null;
    }

    let backgroundUrl = this.state.featuredImage
      ? 'url(' + this.state.featuredImage.helper.webUrl + ')'
      : null;
    const socialSettings = post.get('blog').get('social_media_settings') || {};
    let tags = post.get('tags').models.map(tag => {
      return tag.get('title');
    });

    const picture = this.state.featuredImage
      ? this.state.featuredImage.get('id')
      : socialSettings.picture;

    let back =
      history.length > 2
        ? 'javascript:history.back();'
        : post.get('blog').getLink();

    const subscriberPermission = post.get('blog').get('subscriber_permission');
    const canSubscribe =
      subscriberPermission === 'all'
        ? true
        : subscriberPermission === 'accounts'
        ? !!FW.store.get('user')
        : false;

    let imagePosition = this.props.post.prop('featured_image_alignment') ? this.props.post.prop('featured_image_alignment') : 0.25;
    imagePosition = 'center ' + (imagePosition * 100).toString() + '%';

    let displayDate = this.props.post.get('post_time').endsWith('00:00:00') ? moment(this.props.post.get('post_time')) : moment
      .utc(this.props.post.get('post_time'))
      .local();

    const blog = this.props.post.get('blog');

    return (
      <div className="blogContainer">
        <div className="row blogRow">
          <div className="col-md-12">
            {this.props.post.get('blog').get('display_backlink') ? (
              <a href={back}>
                <h3>
                  <i className="fa fa-arrow-left" aria-hidden="true" /> Back to{' '}
                  {this.props.post.get('blog').get('title')}
                </h3>
              </a>
            ) : null}
            <h1>
              <span>{post.get('title')}</span> {!blog.get('hide_authors_name') ? <small>{post.author}</small> : null}
            </h1>
            {this.state.featuredImage ? (
              <div>
                {post.prop('display_entire_image') ?
                  <img className="blog-featured-image" style={{height: 'auto'}} src={this.state.featuredImage.helper.webUrl} /> :
                  <div
                    className="blog-featured-image"
                    style={{
                      background: backgroundUrl,
                      backgroundSize: 'cover',
                      backgroundPosition: imagePosition
                    }}
                  />
                }
              </div>
            ) : null}
            <div className="post-content-wrapper">
              {post.get('blog').get('hide_dates') ? null : <h4>
                <strong>Posted:</strong>{' '}
                <span>
                  {displayDate
                    .format('MMMM D, YYYY')}
                </span>
              </h4>}
              <div
                style={{width: '100%'}}
                className="post-content"
                data-fw-model="BlogPost"
                data-fw-inline-editable="true"
                data-id={post.get('id')}
              >
                <InlineEditableElement
                  html={post.get('content')}
                  onChange={this.valueChanged}
                  inlineEditingEnabled={this.state.inlineEditingEnabled}
                  fontFamilyChanged={this.fontFamilyChanged}
                />
              </div>
            </div>
            <ShareButtons
              round={shape === 'round' ? 'round' : null}
              show_share_count={
                socialSettings.showShareCount !== null
                  ? socialSettings.showShareCount
                  : true
              }
              disabled={socialSettings.disabled || []}
              url={window.location.href}
              title={post.get('title')}
              picture={picture}
              hashtags={tags.concat(
                socialSettings.hashtags
                  ? socialSettings.hashtags.split(' ')
                  : []
              )}
              description={post.getPreview(80)}
            />
            {canSubscribe ? (
              <SubscribeField blogSlug={post.get('blog').get('slug')} />
            ) : null}
            <div className="post-comments-wrapper" style={{paddingTop: 20}}>
              <CommentBox parent={this.props.post} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlogPost;
